<template>
    <div class="content__wrapper" @click="goTo">
        <div class="content__button">
            <div
                v-if="content.lock"
                data-toggle="tooltip"
                data-placement="bottom"
                :title="$t(content.lock_message)"
            >
                <base-button type="google-plus" class="btn-icon-only rounded-circle">
                    <span class="btn-inner--icon">
                        <i
                        class="display-3"
                        :class="changeIcon"></i>
                    </span>
                </base-button>
            </div>
            <base-button
                v-else
                type="slack"
                @click="goTo"
                class="btn-icon-only rounded-circle lesson-card-color__background"
            >
                <span class="btn-inner--icon">
                    <i class="mdi mdi-play display-3"></i>
                </span>
            </base-button>
        </div>
        <ImageItem
            id="img_card"
            ref="card_img"
            :alt="content.slug"
            content
            :placeholder-h="255"
            :placeholder-w="img_width"
            class="content__img"
            :source="cardImage"
        />
        <div style="padding-right: 2rem !important;" class="container my-4 card__body d-flex flex-wrap">
            <div class="d-flex align-items-center m-auto mb-4">
                <div class="col-1 mr-3 lesson-card-color__text">
                    <i :class="contentIcon(type)" class="display-3"></i>
                </div>
                <div class="col-11 mt-3 desktop-tooltip">
                    <slot>
                        <h3
                            :title="type === 'Exercise' ? content.translation.title : content.translation.name"
                            class="card-title mb-0 lesson-card-color__text"
                        >
                            {{ $trim(type === 'Exercise' ? content.translation.title : content.translation.name, 80) }}
                        </h3>
                    </slot>
                </div>
                <div class="col-11 mt-3 mobile-tooltip">
                    <slot>
                        <h3
                            :title="type === 'Exercise' ? content.translation.title : content.translation.name"
                            class="card-title mb-0 lesson-card-color__text"
                        >
                            {{ $trim(type === 'Exercise' ? content.translation.title : content.translation.name, 80) }}
                        </h3>
                        <i
                            @click="showTooltip = !showTooltip"
                            class="fas fa-info-circle tooltip-icon"
                            >
                        </i>
                    </slot>
                </div>
            </div>
        </div>
        <div
            v-if="content.forum_id"
            class="d-flex justify-content-between align-items-center mx-4"
        >
            <base-button
                :href="`/app/plan/${planId}/${type.toLowerCase()}/forum/${content.forum_id}?iso=${language.iso}`"
                type="outline"
                class="lesson-card-color__forum mobile-forum"
                tag="a"
            >{{ $t('common.forum') }}</base-button>
        </div>
        <div
            class="content__percentage"
            data-toggle="tooltip"
            data-placement="bottom"
            :title="`${content.progress}%`"
        >
            <div
                :style="{'width': `${content.progress}%`}"
                class="percentage__total lesson-card-color__background"
            ></div>
        </div>
        <div class="col-12">
            <button id="continue-button" class="btn-lesson-card lesson-card-color__background">
                {{ content.progress > 0 ? $t('course.continue') : $t('course.start') }}
            </button>
        </div>
    </div>
</template>

<script>
import Card from '../../argon/components/Cards/Card';
import BaseProgress from '../../argon/components/BaseProgress';
import BaseButton from '../../argon/components/BaseButton';
import ContentLock from '../ContentComponents/ContentLock';
import ImageItem from '../Common/ImageItem';
import ContentIcon from '../../mixins/ContentIcon';
import imageMixin from '../../mixins/image';

export default {
    name: 'LessonCard',
    components: {
        Card,
        BaseProgress,
        ContentLock,
        BaseButton,
        ImageItem,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
        content: {
            type: Object,
            required: true,
        },
        planId: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
        },
        publicCourseUrls: {
            type: Object,
            default: () => ({}),
        },
    },
    mixins: [
        ContentIcon,
        imageMixin,
    ],
    data() {
        return {
            img_width: 0,
            showTooltip: false,
        };
    },
    computed: {
        formatedStartDate() {
            const startDate = new Date(this.content.course_publish.start_date);

            const formattedDate = startDate.toISOString().split('T')[0];

            const formattedTime = startDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedDateTimeWithSuffix = `${formattedDate} ${translation} ${formattedTime}`;

            return formattedDateTimeWithSuffix;
        },
        formatedEndDate() {
            const endDate = new Date(this.content.course_publish.end_date);

            const formattedEndDate = endDate.toISOString().split('T')[0];

            const formattedEndTime = endDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedEndDateTimeWithSuffix = `${formattedEndDate} ${translation} ${formattedEndTime}`;

            return formattedEndDateTimeWithSuffix;
        },
        scheduleContent() {
            if (this.content.lock_type === 'SCHEDULE') {
                if (this.content.course_publish && new Date(this.content.course_publish.start_date) > new Date() && this.content.course_publish.start_date != null) {
                    return `${this.$t('course.publish.schedule')} ${this.formatedStartDate} ${this.$t('common.and')} ${this.formatedEndDate}`;
                } else if (this.content.course_publish && new Date(this.content.course_publish.end_date) < new Date() && this.content.course_publish.end_date != null) {
                    return `${this.$t('course.publish.schedule_end')} ${this.formatedEndDate}`;
                }
            }

            if (this.content.course_publish.start_date === null && this.content.course_publish.end_date === null) {
                return this.$t('common.blocked');
            }

            return this.$t('common.blocked');
        },
        changeIcon() {
            if (this.content.lock_type === 'SCHEDULE') {
                const currentDate = new Date().toISOString().split('T')[0];

                if (this.content.course_publish.start_date > currentDate) {
                    return 'mdi mdi-calendar-clock';
                } else if (this.content.course_publish.start_date < currentDate) {
                    return 'mdi mdi-calendar-check';
                }
            } else {
                return 'mdi mdi-lock-outline';
            }
        },
        progressLabel() {
            return this.$t('dashboard.in_progress');
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        cardImage() {
            const { layout } = this.content;
            if (layout && Object.keys(layout).length !== 0 && layout.cardImg) {
                return this.image(this.content.layout.cardImg, 'md');
            }
            return '/img/img-card-plan.jpg';
        },
    },
    methods: {
        showScheduleAlert() {
            return this.$notify({
                type: 'warning',
                message: this.scheduleContent,
            });
        },

        goTo() {
            if (!this.showTooltip && this.content.lock !== true) {
                if (this.type === 'Lesson' && this.publicLessonUrls[this.content.id]) {
                    location.href = this.publicLessonUrls[this.content.id];
                } else if (this.type === 'Course' && this.publicCourseUrls[this.content.id]) {
                    location.href = this.publicCourseUrls[this.content.id];
                } else {
                    // Verifica se estamos em um contexto público
                    const isPublicContext = window.location.pathname.includes('/app/public/plan/');

                    if (isPublicContext) {
                        // URL da API para obter URL assinada
                        let url;
                        if (this.type === 'Lesson') {
                            url = `/api/app/public/plan/${this.planId}/lesson/${this.content.id}/signed-url`;
                        } else if (this.type === 'Course') {
                            url = `/api/app/public/plan/${this.planId}/course/${this.content.id}/signed-url`;
                        }

                        if (url) {
                            window.axios.get(url)
                                .then((response) => {
                                    if (response.data && response.data.url) {
                                        // Armazenar as URLs assinadas para as APIs no localStorage
                                        if (response.data.api) {
                                            localStorage.setItem(
                                                `${this.type.toLowerCase()}_${this.content.id}_api_urls`,
                                                JSON.stringify(response.data.api),
                                            );
                                        }

                                        location.href = response.data.url;
                                    } else {
                                        // Fallback para URL não assinada (provavelmente não funcionará)
                                        const baseUrl = `/app/plan/${this.planId}`;
                                        const contentType = this.type.toLowerCase();
                                        const contentId = this.content.id;
                                        const iso = this.language.iso;
                                        location.href = `${baseUrl}/${contentType}/${contentId}?iso=${iso}`;
                                    }
                                })
                                .catch((error) => {
                                    console.error('Erro ao obter URL assinada:', error);
                                    // Notifica o usuário sobre o erro
                                    this.$notify({
                                        type: 'error',
                                        message: this.$t('common.error_accessing_content'),
                                    });
                                });
                        } else {
                            // Para outros tipos de conteúdo que não têm suporte a URL assinada
                            const baseUrl = `/app/plan/${this.planId}`;
                            const contentType = this.type.toLowerCase();
                            const contentId = this.content.id;
                            const iso = this.language.iso;
                            location.href = `${baseUrl}/${contentType}/${contentId}?iso=${iso}`;
                        }
                    } else {
                        // Comportamento normal para usuários autenticados
                        const baseUrl = `/app/plan/${this.planId}`;
                        const contentType = this.type.toLowerCase();
                        const contentId = this.content.id;
                        const iso = this.language.iso;
                        location.href = `${baseUrl}/${contentType}/${contentId}?iso=${iso}`;
                    }
                }
            } else if (this.content.lock === true) {
                this.showScheduleAlert();
            }
        },
    },
    mounted() {
        const cardImg = this.$refs.card_img;
        if (cardImg && cardImg.$el) {
            this.img_width = cardImg.$el.offsetWidth;
        } else {
            const imgElement = this.$el.querySelector('.content__img');
            if (imgElement) {
                this.img_width = imgElement.offsetWidth;
            }
        }
    },
};
</script>

<style lang="scss">
.content {
    &__wrapper {
        position: relative;
        height: auto;
        padding: 0;
        padding-bottom: 10%;
        background-color: #ffffff;
        border-radius: 8px;
        // box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
        cursor: pointer;
        text-align: center;
    }
    &__wrapper:hover {
        border: 3px solid #5e72e4;

        .lesson-card-color {
            &__background {
                background-color: #5e72e4;
            }
            &__background:focus{
                background-color: #5e72e4;
            }
            &__text {
                color: #5e72e4;
            }
            &__forum {
                color: #5e72e4;
                border-color: #5e72e4;
            }
            &__forum:hover {
                color: #fff;
                border-color: #5e72e4;
                background-color: #5e72e4;
            }
        }
    }
    &__img {
        margin-bottom: 20px;
        height: 255px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        background-color: #cacaca;
    }
    &__button {
        position: absolute;
        top: 225px;
        right: 42%;
        z-index: 10;
    }
    &__percentage {
        margin: 0 40px;
        height: 7px;
        background: #e5e5e5;
        // box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    }
}

.percentage__total {
    filter: contrast(0.5);
    height: inherit;
    border-radius: 5px;
    margin-top: 35px;
}

.btn-icon-only {
    width: 3.575rem !important;
    height: 3.575rem !important;
    padding: 0;
}

.btn-lesson-card {
    margin-top: 35px;
    color: #fff;
    min-height: 36px;
    border: none;
    min-width: 170px;
    border-radius: 5px;
}

.lesson-card-color {
    &__background {
        background-color: #565656;
        border: none;
    }
    &__text {
        color: #565656;
    }
    &__forum {
        color: #565656;
        border-color: #565656;
    }
}
</style>
<style scoped lang="scss">
.tooltip-icon {
    position: absolute;
    top: 0px;
    right: 0px;
}

@media (min-width: 490px) and (max-width: 766px) {
    .mobile-forum {
        margin-bottom: 1rem !important;
    }
}

.mobile-tooltip {
    display: none;
}

@media (max-width: 766px) {
  .mobile-tooltip {
    display: inline-block;
  }
}

@media (max-width: 766px) {
  .desktop-tooltip {
    display: none;
  }
}

.custom-tooltip {
    width: 80%;
    top: 15px !important;
    left: 10px !important;
    opacity: 0.9 !important;
}

.v-tooltip__content {
    background:#616161;
    border-radius:2px;
    color:#fff;
    font-size:12px;
    display:inline-block;
    padding:5px 8px;
    position: absolute !important;
    text-transform:none;
    width:auto;
    box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
}

.v-tooltip__content[class*=-active] {
    transition:.15s cubic-bezier(.25,.8,.5,1);
    pointer-events:none;
}

.v-tooltip__content--fixed {
    position:fixed;
}
</style>
